module.exports = __webpack_public_path__ + "static/media/og07.4e1813cf.webp";